import actionTypes from './actionTypes';

const initialState = {
  gameData: {},
  currentGameTableRef: [],
  highestCard: '',
  legenda: [],
  easyLegenda: [],
  percentage: null,
  similar: [],
  openStats: null,
  stake: null,
  mistakes: {
    mistakes: null,
  },
  option: '',
  opponentPercentage: null,
  cardColor: '',
  heroColor: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${actionTypes.SET_CARD_GAME}_SUCCESS`: {
      return {
        ...state,
        gameData: action.payload.game,
        openStats: action.payload.percentage,
        stake: action.payload.stake,
        option: action.payload.option,
        opponentPercentage: action.payload.opponent_percentage,
      };
    }
    case `${actionTypes.SET_CARD_GAME}_CLEAR`: {
      return {
        ...state,
        gameData: [],
        stake: null,
        option: '',
        opponentPercentage: null,
      };
    }
    case `${actionTypes.SET_CURRENT_GAME_REF}_SUCCESS`: {
      return {
        ...state,
        currentGameTableRef: action.payload.currentGameTableRef,
        highestCard: action.payload.highestCard,
        legenda: action.payload.legenda,
        easyLegenda: action.payload.easyLegenda,
      };
    }
    case `${actionTypes.GET_SIMILAR}_SUCCESS`: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.GET_SIMILAR:
    case `${actionTypes.GET_SIMILAR}_ERROR`:
    case `${actionTypes.GET_SIMILAR}_DROP`: {
      return {
        ...state,
        similar: [],
        percentage: null,
      };
    }
    case `${actionTypes.GET_MISTAKES}_SUCCESS`: {
      return {
        ...state,
        mistakes: action.payload,
      };
    }
    case `${actionTypes.GET_CARD_COLOR}_SUCCESS`: {
      return {
        ...state,
        cardColor: action.payload?.card_color,
      };
    }
    case `${actionTypes.GET_HERO_COLOR}_SUCCESS`: {
      return {
        ...state,
        heroColor: action.payload?.hero_card_color,
      };
    }
    case `${actionTypes.GET_MISTAKES}_CLEAR`: {
      return {
        ...state,
        mistakes: {
          mistakes: null,
        },
      };
    }
    case `${actionTypes.GET_MISTAKES}_ERROR`: {
      return {
        ...state,
        mistakes: {
          mistakes: null,
        },
      };
    }
    default: {
      return state;
    }
  }
};
